import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

function UpdateCogenPlant() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    plant_type_id: "",
    cogen_plant_name: "",
    plant_name: "",
    plant_code: "",
    plant_address: "",
    state: "",
    district: "",
    tehsil: "",
    city: "",
    pincode: "",
    phone_number: "",
    mobile_number: "",
    email: "",
    operational_status: "",
  });

  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    fetch(`https://backend-zkgn.onrender.com/api/cogen/${id}`)
      .then((res) => res.json())
      .then((data) => setFormData(data))
      .catch((err) => console.error("Error fetching plant:", err));
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`https://backend-zkgn.onrender.com/api/cogen/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (res.ok) {
        setSuccessMessage("Plant updated successfully!");
        setTimeout(() => {
          navigate(-1); // go back to the previous page
        }, 1500);
      } else {
        console.error("Update failed.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-center">Edit Cogeneration Plant</h2>

      {successMessage && (
        <div className="alert alert-success text-center" role="alert">
          {successMessage}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">Plant Type ID</label>
            <input
              type="text"
              className="form-control"
              name="plant_type_id"
              value={formData.plant_type_id}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Cogeneration Plant Name</label>
            <input
              type="text"
              className="form-control"
              name="cogen_plant_name"
              value={formData.cogen_plant_name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Plant Name</label>
            <input
              type="text"
              className="form-control"
              name="plant_name"
              value={formData.plant_name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Plant Code</label>
            <input
              type="text"
              className="form-control"
              name="plant_code"
              value={formData.plant_code}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-12">
            <label className="form-label">Plant Address</label>
            <input
              type="text"
              className="form-control"
              name="plant_address"
              value={formData.plant_address}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">City</label>
            <input
              type="text"
              className="form-control"
              name="city"
              value={formData.city}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">Tehsil</label>
            <input
              type="text"
              className="form-control"
              name="tehsil"
              value={formData.tehsil}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">District</label>
            <input
              type="text"
              className="form-control"
              name="district"
              value={formData.district}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">State</label>
            <input
              type="text"
              className="form-control"
              name="state"
              value={formData.state}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">Pin Code</label>
            <input
              type="text"
              className="form-control"
              name="pincode"
              value={formData.pincode}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">Phone Number (Optional)</label>
            <input
              type="text"
              className="form-control"
              name="phone_number"
              value={formData.phone_number}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Mobile Number (Optional)</label>
            <input
              type="text"
              className="form-control"
              name="mobile_number"
              value={formData.mobile_number}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Operational Status</label>
            <select
              className="form-select"
              name="operational_status"
              value={formData.operational_status}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              <option value="Operational">Operational</option>
              <option value="Closed">Closed</option>
            </select>
          </div>
        </div>

        <div className="text-center mt-4">
          <button type="submit" className="btn btn-success px-4">
            Update Cogeneration Plant
          </button>
        </div>
      </form>
    </div>
  );
}

export default UpdateCogenPlant;
